import { Box, Text } from '@rsos/base-components';
import type { TranscriptionStateCall } from '../tabs/TranscriptTab/transcriptionSlice/transcriptionSlice.types';

interface TranscriptHistoryRowProps {
  transcription: TranscriptionStateCall;
  onClick: () => void;
}

const TranscriptHistoryRow = ({
  transcription,
  onClick,
}: TranscriptHistoryRowProps) => {
  const startTime =
    transcription?.payload?.call_information?.call_start_time || 0;
  const tokenCount = transcription?.payload?.tokens?.length || 0;
  const summaryText = transcription?.summaries?.[0]?.summary || '';

  const title = startTime
    ? new Date(startTime).toLocaleString()
    : 'Recent transcript';

  return (
    <Box
      border="1px solid"
      borderColor="heavyLineOutline"
      borderRadius="6px"
      bg="foreground"
      px="12px"
      py="10px"
      style={{ cursor: 'pointer' }}
      onClick={onClick}
      data-name="previous-transcript-row"
    >
      <Text size="normal" color="primaryText" fontWeight="semibold">
        {title}
      </Text>
      {!!summaryText && (
        <Text
          size="small"
          color="secondaryText"
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            marginTop: 2,
          }}
        >
          {summaryText}
        </Text>
      )}
      <Text size="small" color="secondaryText" style={{ marginTop: 6 }}>
        {tokenCount} messages
      </Text>
    </Box>
  );
};

export default TranscriptHistoryRow;
